<template>
    <el-card>
        <el-tabs v-model="activeName">
            <el-tab-pane
                v-if="$$filterPermission('财务-余额管理-提现及银行卡设置')"
                :label="$t('Finance.Balance_manage')"
                name="balance"
                :lazy="true"
                v-once>
                <balance />
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('财务-工资模板-工资模板的设置')"
                :label="$t('Finance.Wage_template')"
                name="salary"
                :lazy="true"
                v-once>
                <salary />
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import Balance from '@/components/widget/Finance/Balance.vue';
import Salary from '@/components/widget/Finance/Salary.vue';
// import cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'Finance',
    components: {
        ElTabs: Tabs,
        ElTabPane: TabPane,
        Balance,
        Salary,
    },
    mixins: [require('../../mixins/CacheQuery').default],
    data() {
        return {
            loading: false,
            editableTabs: [
                {
                    name: 'balance',
                    isShow: this.$$filterPermission('财务-余额管理-提现及银行卡设置'),
                }, {
                    name: 'salary',
                    isShow: this.$$filterPermission('财务-工资模板-工资模板的设置'),
                },
            ],
        };
    },
    created() {
    },
    methods: {
    },
};
</script>

<style lang="scss">
</style>
